import {useState} from 'react';
import {Box, InputAdornment, Typography, Button} from '@mui/material';
import TextField from '@jobseeker/lotus/elements/Input';
import Dialog from '@jobseeker/lotus/components/Dialog';
import {VersionVariants} from '@jobseeker/lotus/enums/variants';
import {Image} from '@jobseeker/lotus/components/Image';
import {SearchIcon} from '@jobseeker/lotus/icons';
import ReactCountryFlag from 'react-country-flag';
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

interface MobileSelectDialogV4Props {
  open: boolean;
  onClose: () => void;
  title: string;
  options: {
    countryCode: string;
    countryName: string;
    countryCodeAlpha: string;
  }[];
  subtitle?: string;
  allowSearch?: boolean;
  label?: string;
  onChange: (value: string) => void;
  value?: any;
}

const MobileSelectDialogV4: React.FC<MobileSelectDialogV4Props> = ({
  open,
  onClose,
  title,
  options,
  subtitle,
  allowSearch = false,
  label,
  onChange,
  value,
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const filteredOptions = allowSearch
    ? options.filter(option =>
        option.countryName
          .toLowerCase()
          .trim()
          .includes(searchQuery.toLowerCase().trim())
      )
    : options;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      invertedTitle={false}
      variant={VersionVariants.VERSION_SEVEN}
      subtitle={subtitle}
    >
      {allowSearch && (
        <Box>
          <Box paddingLeft={'16px'} paddingRight={'16px'} paddingTop={'16px'}>
            <TextField
              fullWidth
              placeholder={`${label}`}
              value={searchQuery}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Image
                      src={SearchIcon}
                      alt="search"
                      width={16}
                      height={16}
                    />
                  </InputAdornment>
                ),
              }}
              sx={{
                '.MuiInputBase-input': {
                  border: 'unset !important',
                  fontSize: '12px !important',
                  paddingLeft: 0,
                  py: '13px',
                },
                '.MuiInputBase-input::placeholder': {
                  fontSize: '12px',
                  fontWeight: 400,
                  fontStyle: 'normal',
                  color: '#7E7E7E',
                  opacity: 0.8,
                },
                mb: '8px',
              }}
              onChange={e => setSearchQuery(e.target.value)}
              // sx={{
              //   mb: 2,
              //   '& .MuiOutlinedInput-root': {
              //     borderRadius: '8px',
              //   },
              // }}
              onKeyDown={e => {
                if (e.key !== 'Escape') {
                  // Prevents autoselecting item while typing (default Select behaviour)
                  e.stopPropagation();
                }
              }}
              variant={VersionVariants.VERSION_TWO}
            />
          </Box>
          <Box sx={{height: '400px', maxHeight: '400px', overflowY: 'auto'}}>
            {filteredOptions.length > 0 ? (
              filteredOptions.map(country => (
                <Box
                  onClick={() => {
                    onChange(country.countryCode);
                    onClose();
                    setSearchQuery('');
                  }}
                  sx={{
                    // padding: '10px 8px',
                    paddingLeft: '16px',
                    paddingBottom: '11px',
                    paddingTop: '11px',
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    transition: 'background 0.2s',
                    backgroundColor:
                      country.countryCode == value
                        ? isAppIimjobs
                          ? '#91B87929'
                          : 'rgba(233, 99, 12, 0.08)'
                        : 'white',
                    // '&:hover': {
                    //   backgroundColor: '#f5f5f5',
                    // },
                  }}
                >
                  <ReactCountryFlag
                    countryCode={country.countryCodeAlpha}
                    svg
                    style={{
                      marginRight: '8px',
                      width: '20px',
                      height: '14px',
                    }}
                  />
                  <Typography
                    sx={{
                      fontWeight: 400,
                      fontSize: '12px',
                      marginRight: '8px',
                    }}
                  >
                    {country.countryName}
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 400,
                      fontSize: '12px',
                      color: '#7E7E7E',
                    }}
                  >
                    ({country.countryCode})
                  </Typography>
                </Box>
              ))
            ) : (
              <Box height={'400px'}>
                <Typography
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    color: '#7E7E7E',
                    fontSize: '12px',
                    fontWeight: 400,
                    opacity: 1,
                    mt: 1,
                    paddingLeft: '16px',
                    paddingTop: '8px',
                    paddingBottom: '8px',
                  }}
                >
                  No results found
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      )}
    </Dialog>
  );
};

export default MobileSelectDialogV4;
